import React from 'react';

import { GreenIcon } from '@assets/icon';
import { PermissionEnum } from '@modules/permissions/entity';
import { IRouter } from '@routers/interface';

import routerExchangeGifts2 from './Pages/ExchangeGifts2/router';
import routerGiftByDevice from './Pages/GiftByDevice/router';
import routerGiftDistributionHistory from './Pages/GiftDistributionHistory/router';

export const routerGifts: IRouter = {
  path: null,
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'gifts.router.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  menu: {
    icon: <GreenIcon />,
    activePath: '/gifts',
  },
  permissionCode: [
    PermissionEnum.RewardItemsView,
    PermissionEnum.DeviceRewardItemsView,
    PermissionEnum.RewardRedemptionsView,
  ],
  routes: [routerExchangeGifts2, routerGiftByDevice, routerGiftDistributionHistory],
};
